import "core-js";
import "isomorphic-fetch";
import "../scss/style.scss";
window.dataLayer = window.dataLayer || [];
import Cookies from "js-cookie";
import "./App";
import "./Rating";
import "./Sharer";
import "./searchBar";
import smoothscroll from "smoothscroll-polyfill";

if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}


smoothscroll.polyfill();

if (window.innerWidth < 1141) {
  document.querySelectorAll(".nav-item").forEach((el) => {
    el.addEventListener("click", (event) => {
      if (el.classList.contains("active")) {
        if (!event.target.closest(".sub")) {
          event.preventDefault();
          el.classList.remove("active");
          el.parentElement.classList.remove("submenu-active");
        }
      } else {
        if (el.querySelector(".sub") !== null) {
          event.preventDefault();
          document
            .querySelectorAll(".nav-item.active")
            .forEach((el) => el.classList.remove("active"));
          el.parentElement.classList.add("submenu-active");
          el.classList.add("active");
          const height = el.querySelector(".sub").getBoundingClientRect()
            .height;
          if (height > window.innerHeight)
            el.parentElement.style.height = `${height}px`;
        }
      }
    });
  });
}

document.addEventListener("click", (event) => {
  if (event.target.closest(".header nav")) return;
  document
    .querySelectorAll(".nav-item.active")
    .forEach((el) => el.classList.remove("active"));
});

document.querySelector(".menu-toggle").addEventListener("click", (event) => {
  event.preventDefault();
  const header = document.querySelector(".header");
  if (header.classList.contains("menu-active")) {
    header.classList.remove("menu-active");
    document.querySelectorAll(".nav-item.active").forEach((el) => {
      el.classList.remove("active");
      el.parentElement.classList.remove("submenu-active");
    });
  } else {
    header.classList.add("menu-active");
  }
});

document.querySelector(".menu-back-btn").addEventListener("click", (event) => {
  event.preventDefault();
  document.querySelectorAll(".nav-item.active").forEach((el) => {
    el.classList.remove("active");
    el.parentElement.classList.remove("submenu-active");
  });
});

const calendarCtaPopup = document.querySelector(".calendarCtaPopup");

if (calendarCtaPopup !== null) {
  const closeCalendarCtaPopup = () => {
    calendarCtaPopup.classList.remove("active");
    Cookies.set("calendar-cta-popup", "1", {
      expires: 7,
    });
  };

  if (typeof Cookies.get("calendar-cta-popup") === "undefined") {
    setTimeout(() => {
      calendarCtaPopup.classList.toggle("active");
    }, 3000);
  }

  document
    .querySelector(".calendarCtaPopup .btn")
    .addEventListener("click", (e) => {
      e.preventDefault();
      closeCalendarCtaPopup();
    });

  document
    .querySelector(".calendarCtaPopup a.closeLink")
    .addEventListener("click", (e) => {
      e.preventDefault();
      closeCalendarCtaPopup();
    });
}

document.addEventListener("click", function (e) {
  if (e.target.closest(".calender__changeViewBtn")) {
    window.dataLayer.push({
      event: "changeCalendarView",
      view: e.target.dataset.view,
    });
  }
});

window.cookieconsent.initialise({
  palette: {
    popup: {
      background: "#ffffff",
      text: "#838391",
    },
    button: {
      background: "#4b81e8",
    },
  },
  position: "bottom-right",
  content: {
    message: "Door deze website te gebruiken, gaat u akkoord met ons",
    link: "cookiebeleid",
    href: "/privacy",
  },
  // elements: {
  //   dismiss:
  //     '<a aria-label="dismiss cookie message" tabindex="0" class="btn cc-dismiss"><i class="fal fa-times"></i></a>',
  // },
  elements: {
    dismiss:
      '<a aria-label="dismiss cookie message" role="button" tabindex="0" class="cc-btn btn cc-dismiss"><i class="fal fa-times"></i></a>',
  },
  dismissOnTimeout: 10000,
  dismissOnScroll: 400,
});

document.querySelectorAll(".anchor-links-list a").forEach((el) =>
  el.addEventListener("click", (e) => {
    if (el.getAttribute("href").startsWith("#")) {
      e.preventDefault();
      const targetEl = document.getElementById(
        el.getAttribute("href").replace("#", "")
      );
      window.scroll({
        top: targetEl.getBoundingClientRect().top - 80,
        behavior: "smooth",
      });
    }
  })
);
